import {
  Anchor,
  Badge,
  Box,
  Button,
  Divider,
  Flex,
  Group,
  ScrollArea,
  Stack,
  Text,
  Title,
  Tooltip,
  useMantineTheme,
} from '@mantine/core'
import classes from './Profile.module.css'
import ExampleUser from '@assets/exampleUser.png'
import {
  IconArrowRight,
  IconArrowUp,
  IconClockCheck,
  IconHome,
  IconListCheck,
  IconMail,
  IconPhone,
  IconPlus,
} from '@tabler/icons-react'
import { Dot } from '@components/Dot/Dot'

export const Profile = () => {
  const theme = useMantineTheme()

  return (
    <Box className={classes.Record__profile}>
      <ScrollArea h="100%">
        <Stack gap="xs" pb="md">
          <Flex justify="center" mt="md">
            <Box className={classes.Record__profile__photo}>
              <img src={ExampleUser} />
              <Tooltip label="Online">
                <div className={classes.Record__profile__photoStatus} />
              </Tooltip>
            </Box>
          </Flex>
          <Stack align="center" gap={0}>
            <Title order={3}>Alfredo Carrillo</Title>
            <Text fs="italic" size="sm">
              Fredo
            </Text>
            <Box className={classes.Record__profile__tag} mt="xs">
              <Text c="gray.7" tt="uppercase">
                Severe Health Condition
              </Text>
            </Box>
            <Group gap="xs" mt="sm">
              <Button leftSection={<IconPlus size={18} />} size="xs">
                Task
              </Button>
              <Button size="xs" leftSection={<IconPlus size={18} />}>
                Note
              </Button>
              <Button size="xs" leftSection={<IconArrowUp size={18} />}>
                File
              </Button>
            </Group>
            <Group gap="xl" mt="xs">
              <Anchor size="sm">Request Edit Access</Anchor>
              <Anchor size="sm">Request Data Share</Anchor>
            </Group>
          </Stack>
          <Divider w="100%" color="gray.3" my="xs" />
          <Stack px="md" gap="xs">
            <Title order={6}>Activity</Title>
            <Group gap="xs">
              <IconListCheck size={22} />
              <Anchor size="sm">2 Pending tasks</Anchor>
            </Group>
            <Group gap="xs">
              <IconArrowRight size={22} />
              <Text size="sm">Touched 2 days ago</Text>
            </Group>
            <Group gap="xs">
              <IconClockCheck size={22} />
              <Text size="sm" fs="italic">
                Record updated yesterday
              </Text>
            </Group>
          </Stack>
          <Divider w="100%" color="gray.3" my="xs" />

          <Stack px="md" gap="sm">
            <Title order={6}>Contact</Title>
            <Box w="100%">
              <Flex gap="xs">
                <IconMail size={22} />
                <Stack style={{ flexGrow: 1 }} gap={5}>
                  <Flex gap="xs" justify="space-between">
                    <Flex align="center" gap="xs">
                      <Anchor size="sm">acarrillo@mybluecard.org</Anchor>
                      <Dot color="green.5" tooltip="Valid" />
                    </Flex>
                    <Text size="xs" c="gray.6">
                      work
                    </Text>
                  </Flex>
                  <Flex gap="xs" justify="space-between">
                    <Flex align="center" gap="xs">
                      <Anchor size="sm">alfredo@gmail.com</Anchor>
                      <Dot color="green.5" tooltip="Valid" />
                    </Flex>
                    <Text size="xs" c="gray.6">
                      work
                    </Text>
                  </Flex>
                </Stack>
              </Flex>
            </Box>

            <Box w="100%">
              <Flex gap="xs">
                <IconPhone size={22} />
                <Stack style={{ flexGrow: 1 }} gap={5}>
                  <Flex gap="xs" justify="space-between">
                    <Flex align="center" gap="xs">
                      <Anchor size="sm">+1 (555) 555-5555</Anchor>
                      <Dot color="gray.4" tooltip="No status" />
                    </Flex>
                    <Text size="xs" c="gray.6">
                      mobile
                    </Text>
                  </Flex>
                  <Flex gap="xs" justify="space-between">
                    <Flex align="center" gap="xs">
                      <Anchor size="sm">+1 (666) 666-6666</Anchor>
                      <Dot color="orange.9" tooltip="Questionable" />
                    </Flex>
                    <Text size="xs" c="gray.6">
                      work
                    </Text>
                  </Flex>
                  <Flex gap="xs" justify="space-between">
                    <Flex align="center" gap="xs">
                      <Anchor size="sm">+1 (777) 777-7777</Anchor>
                      <Dot color="red.7" tooltip="Invalid" />
                    </Flex>
                    <Text size="xs" c="gray.6">
                      home
                    </Text>
                  </Flex>
                </Stack>
              </Flex>
            </Box>

            <Box w="100%">
              <Flex gap="xs">
                <IconHome size={22} />
                <Stack style={{ flexGrow: 1 }} gap={5}>
                  <Flex gap="xs" justify="space-between">
                    <Anchor
                      href="https://www.google.com/maps/place/1573+Madison+Ave,+New+York,+NY+10029"
                      size="sm"
                      target="_blank"
                    >
                      1573 Madison Ave.
                      <br />
                      New York, NY 10029-3819
                    </Anchor>
                    <Text size="xs" c="gray.6">
                      home
                    </Text>
                  </Flex>
                  <Flex gap="xs" justify="space-between">
                    <Stack gap={0}>
                      <Anchor
                        href="https://www.google.com/maps/place/505+Park+Ave,+New+York,+NY+10022"
                        size="sm"
                        target="_blank"
                      >
                        505 Park Ave,
                        <br />
                        New York, NY 10022
                      </Anchor>
                    </Stack>
                    <Text size="xs" c="gray.6">
                      work
                    </Text>
                  </Flex>
                </Stack>
              </Flex>
            </Box>
          </Stack>

          <Divider w="100%" color="gray.3" my="xs" />

          <Stack px="md" gap="sm">
            <Stack gap={5}>
              <Title order={6}>Persona</Title>
              <Badge variant="outline" color="gray" size="lg">
                Parent
              </Badge>
            </Stack>
            <Stack gap={5}>
              <Title order={6}>Stage</Title>
              <Badge
                variant="light"
                color="blue.3"
                size="lg"
                style={{
                  color: theme.colors.gray[7],
                  border: `solid 1px ${theme.colors.blue[5]}`,
                }}
              >
                Nurture
              </Badge>
            </Stack>
            <Stack gap={5}>
              <Title order={6}>Tags</Title>
              <Text size="sm">Severe Health Condition, PTA, Donor</Text>
            </Stack>
          </Stack>

          <Divider w="100%" color="gray.3" my="xs" />

          <Stack px="md" gap="sm">
            <Group align="center">
              <Title order={6}>Notes</Title>
              <Text size="sm" fs="italic" c="gray.5">
                Private to you
              </Text>
            </Group>
            <Text size="sm">This is where notes would go.</Text>
          </Stack>

          <Divider w="100%" color="gray.3" my="xs" />

          <Stack px="md" gap="sm">
            <Title order={6}>Personal Info</Title>
            <Stack gap="xs">
              <Text size="sm" c="gray.6">
                First name:{' '}
                <Text c="dark" span>
                  Alfredo
                </Text>
              </Text>
              <Text size="sm" c="gray.6">
                Last name:{' '}
                <Text c="dark" span>
                  Carrillo
                </Text>
              </Text>
            </Stack>
          </Stack>
        </Stack>
      </ScrollArea>
    </Box>
  )
}
